import { withJWTClient } from "./connectClient";

const API_BASE_URL: string =
  (import.meta.env.VITE_HOST_INTEGRATIONS_API_URL as string) || "";

interface YotpoInstallResponse {
  redirectUrl: string;
}

export async function getYotpoInstallUrl(siteId: string): Promise<string> {
  const response = await withJWTClient((client) =>
    client.get<YotpoInstallResponse>(
      `${API_BASE_URL}/${siteId}/integrations/yotpo/install`,
    ),
  );

  if (!response.data.redirectUrl) {
    throw new Error("No redirect URL in response");
  }

  return response.data.redirectUrl;
}
